

import {
  Box,
  Divider,
  LinearProgress,
  useMediaQuery,
  Button,
  CircularProgress,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
import back from "../../../../assets/back.svg";
import projecticon from "../../../../assets/Projects/projecticon.svg";
import Progress from "../../../../assets/Projects/Progress.svg";
import document1 from "../../../../assets/document1.svg";
import document2 from "../../../../assets/Projects/document2.png";
import AddIcon from "@mui/icons-material/Add";
import StatusDropdown from "../../../../components/StatusDropdown";
import person1 from "../../../../assets/Dashboard/person1.svg";
import activity from "../../../../assets/Projects/activity.png";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { BASE_URL } from "../../../../components/BaseUrl";
import TaskStatusDropdown from "../../../../components/TaskStatusDropdown.js";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import emptyperson from "../../../../assets/emptyperson.jpeg";
import CustomButton from "../../../../components/CustomButton.js";
import WorkerStatusDropdown from "../../../../components/workerUpdateStatus.js";
import ClearIcon from "@mui/icons-material/Clear";
import RatingModal from "./RatingModal.js";
import ConfirmActionModal from "./updateComfirmatiomModal.js";
import {toast} from "react-hot-toast"
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";
import { getStatusBadgeBackgroundColor } from "../../../../constants/statusPalette";
const TaskDetails = ({ task, onBack, onRefresh }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t, i18n } = useTranslation();
    const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [comments, setComments] = useState([]);
const [taskDetailsData, setTaskDetailsData] = useState(null);

  useEffect(() => {
    if (taskDetailsData?.comments) {
      setComments(taskDetailsData.comments);
    } else if (task?.comments) {
      setComments(task.comments);
    }
  }, [task, taskDetailsData]);
  const [newComment, setNewComment] = useState("");
  const [sending, setSending] = useState(false);


const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const formattedDateTime = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    },
  });

  return formattedDateTime === "—" ? "-" : formattedDateTime;
};
const [commentAttachment, setCommentAttachment] = useState(null); // uploaded file URL

const [uploadingAttachment, setUploadingAttachment] = useState(false);
const user = useSelector((state) => state.auth.user);
const detailedTask = taskDetailsData?.task || task;
const assignmentDetails = taskDetailsData?.assignments?.[0] || task?.assignments?.[0];
// Scope start/end events to the same worker as assignmentDetails — for multi-assignee tasks,
// picking the globally-latest event of each type (ignoring which worker it belongs to) could
// show a different worker's validation result than the one whose name/timing is displayed above.
const startEvent = taskDetailsData?.events?.find(
  (eventItem) =>
    eventItem?.event_type === "start" &&
    (!assignmentDetails?.worker_id || eventItem?.worker_id === assignmentDetails.worker_id)
);
const endEvent = taskDetailsData?.events?.find(
  (eventItem) =>
    eventItem?.event_type === "end" &&
    (!assignmentDetails?.worker_id || eventItem?.worker_id === assignmentDetails.worker_id)
);

const formatReadableText = (text) => {
  if (typeof text !== "string") return text;
  return text
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const getEventDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "--";
  if (typeof value === "boolean") return value ? t("yes") : t("no");
  if (typeof value === "string") return formatReadableText(value);
  return value;
};

const formatDelayMinutes = (minutes) => {
  if (minutes === null || minutes === undefined || minutes === "") return "--";
  const total = Math.round(Number(minutes));
  if (Number.isNaN(total)) return "--";
  const absTotal = Math.abs(total);
  const h = Math.floor(absTotal / 60);
  const m = absTotal % 60;
  const parts = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0 || parts.length === 0) parts.push(`${m} min`);
  return parts.join(" ");
};

const renderDetailsRow = (label, value, key) => (
  <Box
    key={key || label}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
    }}
  >
    <CustomText
      sx={{
        ...textStyles.h1,
        fontSize: 16,
        fontWeight: 400,
        color: "#5E5C5C",
        textAlign: "left",
      }}
    >
      {label}
    </CustomText>
    <CustomText
      sx={{
        ...textStyles.h1,
        fontSize: 15,
        fontWeight: 400,
        color: "#172B4D",
        textAlign: "right",
      }}
    >
      {value}
    </CustomText>
  </Box>
);

const resolveFaceImageUrl = (url) => {
  if (!url || typeof url !== "string") return null;

  // Case 1: absolute/local string containing /api/uploads/...
  const apiUploadsIndex = url.indexOf("/api/uploads/");
  if (apiUploadsIndex !== -1) {
    // BASE_URL already includes /api
    // Keep "/api/uploads/..." from source URL
    return `${BASE_URL}${url.slice(apiUploadsIndex + 4)}`;
  }

  // Case 2: full http(s) URL
  if (url.startsWith("http://") || url.startsWith("https://")) {
    try {
      const source = new URL(url);
      const base = new URL(BASE_URL);

      // If backend host differs, rewrite uploads URL to current API host
      if (source.pathname.startsWith("/api/uploads/") && source.origin !== base.origin) {
        return `${BASE_URL}${source.pathname.replace(/^\/api/, "")}`;
      }
    } catch (err) {
      console.warn("Failed to parse face image URL:", url, err);
    }

    return url; // already usable
  }

  // Case 3: relative path like /uploads/...
  const uploadsIndex = url.indexOf("/uploads/");
  if (uploadsIndex !== -1) {
    return `${BASE_URL}${url.slice(uploadsIndex)}`;
  }

  return null;
};

const isPdfUrl = (url) =>
  typeof url === "string" && url.toLowerCase().split("?")[0].endsWith(".pdf");

const renderEvidenceGallery = (files) => {
  const list = (Array.isArray(files) ? files : []).filter((url) => typeof url === "string" && url);
  if (list.length === 0) return "--";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-end" }}>
      {list.map((url, idx) => {
        const resolvedUrl = resolveFaceImageUrl(url) || url;
        return (
          <a
            key={idx}
            href={resolvedUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex" }}
          >
            {isPdfUrl(url) ? (
              <Box
                component="img"
                src={document1}
                alt="Evidence document"
                sx={{
                  width: 48,
                  height: 48,
                  objectFit: "contain",
                  borderRadius: "8px",
                  border: "1px solid #E4E6EF",
                  cursor: "pointer",
                  p: 0.5,
                  backgroundColor: "#F9FAFB",
                }}
              />
            ) : (
              <Box
                component="img"
                src={resolvedUrl}
                alt="Evidence"
                crossOrigin="anonymous"
                sx={{
                  width: 48,
                  height: 48,
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid #E4E6EF",
                  cursor: "pointer",
                }}
              />
            )}
          </a>
        );
      })}
    </Box>
  );
};

const fetchTaskDetails = async () => {
  if (!task?.id || !decryptedToken) return;
  try {
    const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${task.id}`, {
      headers: {
        Authorization: `Bearer ${decryptedToken}`,
      },
    });
    const data = await res.json();
    if (!res.ok || data?.error) {
      throw new Error(data?.message || "Failed to fetch task details");
    }
    setTaskDetailsData(data?.data || null);
  } catch (err) {
    console.error("❌ Error fetching task details:", err);
  }
};

useEffect(() => {
  fetchTaskDetails();
}, [task?.id, decryptedToken]);

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("image", file);

  try {
      setUploadingAttachment(true);
    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();

    if (!data.error && data.data?.url) {
      setCommentAttachment(data.data.url);
      toast.success("Attachment uploaded!");
    } else {
      toast.error("Failed to upload attachment");
    }
  } catch (err) {
    console.error("❌ Upload error:", err);
    toast.error("Error uploading file");
  }
  finally {
    setUploadingAttachment(false); // stop loader
  }
};
  const [openModal, setOpenModal] = useState(false); // State to control modal visibility
  const [selectedAction, setSelectedAction] = useState(null);
    const [taskState, setTask] = useState(task);  // Store the task data

const handleApiCall = async (reasonOrNotes) => {
  const taskId = task.id; // Assuming task has an id

  if (!token) {
toast.error(t("apiCallFailed"));
    return;
  }

  try {
    let response;

    // Check if the action is "cancel"
    if (selectedAction === "cancel") {
      response = await fetch(`${BASE_URL}/task-management/admin/tasks/${taskId}/cancel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${decryptedToken}`, // Add token to the header
        },
        body: JSON.stringify({
          reason: reasonOrNotes,
        }),
      });
    } 
    // Check if the action is "complete"
    else if (selectedAction === "complete") {
      response = await fetch(`${BASE_URL}/task-management/admin/tasks/${taskId}/complete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${decryptedToken}`, // Add token to the header
        },
        body: JSON.stringify({
          notes: reasonOrNotes, // Pass the notes from the modal
        }),
      });
    }

    // Handle the response from the API
    const data = await response.json();
    if (!response.ok || data?.error) throw new Error(data?.message || "API call failed");

    // On success, update the task status in the state
    if (selectedAction === "cancel") {
      task.status = "cancelled"; // Update the task status in the UI
    } else if (selectedAction === "complete") {
      task.status = "completed"; // Update the task status in the UI
    }

toast.success(`${selectedAction === "cancel" ? t("taskCanceled") : t("taskCompleted")} successfully!`);

    // Optionally: Trigger a re-render with updated task data
    setTask({ ...task }); // This will trigger a re-render if `task` is in the state

    // Pull the fresh task details (assignments/events) right away so the End Task
    // validation section shows up without needing a page refresh.
    await fetchTaskDetails();

  } catch (err) {
    console.error("❌ [API Error] Error:", err);
    toast.error(err.message || "There was an error with the API call.");
  } finally {
    setOpenModal(false); // Close the modal after the action is confirmed
  }
};

  const handleStatusChange = (action) => {
    setSelectedAction(action);
    setOpenModal(true); // Open modal to confirm
  };
const handleAddComment = async () => {
  if (!newComment.trim() && !commentAttachment) return;

  setSending(true);
  try {
    const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${task.id}/comments`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify({
        body: newComment,
        attachments: commentAttachment ? [commentAttachment] : [],
      }),
    });

    const data = await res.json();
    if (!data.error) {
      // setComments((prev) => [...prev, data.data.comment]);
     const c = data.data.comment;

// add missing fields so UI works instantly
c.author_name = c.user?.name;
c.author_email = c.user?.email;

setComments((prev) => [...prev, c]);
      setNewComment("");
      setCommentAttachment(null);
    } else {
      toast.error(data.message || t("projectManagement.toast.commentAddFailed"));
    }
  } catch (err) {
    console.error("❌ Error adding comment:", err);
    toast.error(t("projectManagement.toast.commentAddError"));
  } finally {
    setSending(false);
  }
};

const [updatingPriority, setUpdatingPriority] = useState(false);

const handlePriorityChange = async (newPriority) => {
  setUpdatingPriority(true);
  try {
    const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${task.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: JSON.stringify({ priority: newPriority }),
    });

    const data = await res.json();
    if (!data.error) {
      task.priority = newPriority; // update UI
      toast.success(t("projectManagement.toast.priorityUpdated"));
      window.dispatchEvent(new Event('tasks:updated')); // ✅ refresh calendar & map
    } else {
      toast.error(data.message || t("projectManagement.toast.priorityUpdateFailed"));
    }
  } catch (err) {
    console.error("❌ Error updating priority:", err);
    toast.error(t("projectManagement.toast.priorityUpdateError"));
  } finally {
    setUpdatingPriority(false);
  }
};

 const [openRatingModal, setOpenRatingModal] = useState(false);

  // Open Rating Modal
  const handleAddRatingClick = () => {
    setOpenRatingModal(true);
  };

  // Close Rating Modal
  const handleCloseRatingModal = () => {
    setOpenRatingModal(false);
  };

  // Callback function when rating is added/edited
  const handleRatingSubmit = () => {
    // Refresh task details after rating submission
    if (task?.id && onRefresh) {
      onRefresh(task.id);
    }
  };

  if (!task) {
    return (
         <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
      }}
    >
      <CircularProgress size={40} /> 
    </Box>
    );
  }
    const handleRemoveAttachment = () => {
    setCommentAttachment(null); // Remove the attachment
  };
  const getProgressValue = (status) => {
  switch (status?.toLowerCase()) {
    case "assigned":
      return 0;
    case "open":
      return 20;
    case "in_progress":
      return 60;
    case "completed":
      return 100;
    default:
      return 0; // fallback
  }
};
  return (
    <>
    

      <Box sx={{ p: isMobile ? 1 : 0 }}>
        {/* Back Bar */}
         <Box
          sx={{
            border: "1px solid #E4E6EF",
            borderRadius: 2,
            px: 2,
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            minHeight: 55,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
            }}
            onClick={onBack}
          >
            <img src={back} style={{ width: 30, height: 30 }} alt="back" />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "14px",
                color: "#626F86",
              }}
            >      {t("projectManagement.allTasks")} / {task.title}
            </CustomText>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 3,
            alignItems: isMobile ? "flex-start" : "stretch",
          }}
        >
          <Box
            flex={2}
            sx={{
              backgroundColor: "#fff",
              p: 2,
              borderRadius: 2,
              height: "100%",
              border: "1px solid #E4E6EF",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center",justifyContent:"space-between" ,flexWrap:"wrap", pt: 1,mb:1}}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1,}}>
              {/* <img src={projecticon} style={{ width: 25, height: 25 }} /> */}
              <CustomText
                sx={{
                  fontSize: 16,
                  color: "#172B4D",
                  fontWeight: 500,
                  mb: 0,
                  fontFamily: "Poppins, sans-serif",
                }}
              >
 {task.id}              </CustomText>
                  </Box>
              <Box >
                   {/* <Box sx={{ pointerEvents: "none" }}> */}

<TaskStatusDropdown
  currentStatus={task.priority}
  onChange={handlePriorityChange}
  loading={updatingPriority}
/>
        {/* </Box> */}
              </Box>
          
            </Box>

            {renderDetailsRow(
              t("projectManagement.taskName"),
              detailedTask?.title || task?.title || "—",
              "task-title"
            )}
            {renderDetailsRow(
              t("projectManagement.description"),
              detailedTask?.description || task?.description || "—",
              "task-description"
            )}

           
      

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.taskDetails")}
            </CustomText>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedTo")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
  {assignmentDetails?.worker_name || "—"}
              </CustomText>{" "}
            </Box>




            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("workeremail")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
  {assignmentDetails?.worker_email|| "—"}
              </CustomText>{" "}
            </Box>

               <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.status")}
              </CustomText>
     <Box  sx={{display:"flex",alignItems:"center",gap:1,flexWrap:"wrap"}}>          
<Box sx={{ pointerEvents: task.status === "cancelled" || task.status === "completed" ? "none" : "auto" }}>
  <WorkerStatusDropdown
    currentStatus={task.status}
    onChange={handleStatusChange}
    statusOptions={task.status !== "cancelled" && task.status !== "completed" ? ["cancel", "complete"] : []}
    showArrow={task.status !== "cancelled" && task.status !== "completed"}
  />
</Box>
   {task.status === "completed" && (
          <CustomButton 
            label={task.productivity_rating ? t("editRating") || "Edit Rating" : t("addRating")} 
            size='small' 
            onClick={handleAddRatingClick} 
            sx={{py:0.4,}}
          />
        )}
            </Box>   
               {" "}
              {/* </Box> */}
            </Box>


                 <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("productivityRating")}
              </CustomText>
             <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                lineHeight: 1.8,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {task.productivity_rating || "--"}
            </CustomText>{" "}
            </Box>
                 <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("ratingNotes")}
              </CustomText>
               <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 15,
                fontWeight: 400,
                lineHeight: 1.8,
                color: "#5E5C5C",
                textAlign: "left",
              }}
            >
           {task.productivity_notes || "--"}
            </CustomText>{" "}
            </Box>

     <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.assignedOn")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
{formatDateTime(detailedTask?.assigned_on)}
     </CustomText>{" "}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.deadline")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                {/* {task.end_at}{" "} */}
                 {formatDateTime(detailedTask?.end_at)}
              </CustomText>{" "}
            </Box>



            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("location")}
              </CustomText>
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "right",
                }}
              >
                {/* {task.end_at}{" "} */}
              {detailedTask?.location_address}
              </CustomText>{" "}
            </Box>

       
          

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.priority")}
              </CustomText>
                           <Box sx={{ pointerEvents: "none" }}>
    <StatusDropdown currentStatus={task.priority} />{" "}
    </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "#5E5C5C",
                  textAlign: "left",
                }}
              >
                {t("projectManagement.progress")}
              </CustomText>
              {/* <CustomText
                sx={{
                  ...textStyles.h1,
                  fontSize: 15,
                  fontWeight: 400,
                  color: "#172B4D",
                  textAlign: "left",
                }}
              >
                <img src={Progress} /> 33%
              </CustomText>{" "} */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 120 }}>
  <LinearProgress
    variant="determinate"
    value={getProgressValue(task.status)}
    sx={{
      flex: 1,
      height: 8,
      borderRadius: 5,
      backgroundColor: "#E4E6EF",
      "& .MuiLinearProgress-bar": {
        backgroundColor: getStatusBadgeBackgroundColor(task.status || "assigned"),
      },
    }}
  />
  <Typography
    sx={{
      fontSize: 14,
      fontWeight: 500,
      color: "#172B4D",
      fontFamily: "Poppins, sans-serif",
      minWidth: 35,
      textAlign: "right",
    }}
  >
    {getProgressValue(task.status)}%
  </Typography>
</Box>
            </Box>
            
            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 2,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("taskDetailsLabels.taskStartDetails")}
            </CustomText>
            <Box  sx={{
              border: "2px solid  #091E4224",
              borderRadius: "10px",
              px: 2,
              py: 2,
              mt: 1.5,
              mb: 2.5,
              // backgroundColor: "#FBFCFE",
            }}
            >
              {[
                [t("taskDetailsLabels.scheduledStart"), formatDateTime(assignmentDetails?.timing?.scheduled_start_at)],
                [t("taskDetailsLabels.actualStart"), formatDateTime(assignmentDetails?.timing?.actual_start_at)],
                [t("taskDetailsLabels.startStatus"), getEventDisplayValue(assignmentDetails?.timing?.start_time_status)],
                [t("taskDetailsLabels.startDelayMinutes"), formatDelayMinutes(assignmentDetails?.timing?.start_delay_minutes)],
                [t("taskDetailsLabels.faceVerificationStart"), getEventDisplayValue(assignmentDetails?.validation_start?.face_validated ?? startEvent?.face_validated)],
                [t("taskDetailsLabels.locationVerificationStart"), getEventDisplayValue(assignmentDetails?.validation_start?.location_validated ?? startEvent?.location_validated)],
                [t("taskDetailsLabels.systemCheckStatusStart"), getEventDisplayValue(assignmentDetails?.validation_start?.system_validation_status ?? startEvent?.system_validation_status)],
                [t("taskDetailsLabels.reviewStatus"), getEventDisplayValue(startEvent?.review_status)],
                [
                  t("taskDetailsLabels.capturedPhotoStart"),
                  assignmentDetails?.validation_start?.face_image_url
                    ? (
                      <a
                        href={resolveFaceImageUrl(assignmentDetails?.validation_start?.face_image_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "inline-flex" }}
                      >
                        <Box
                          component="img"
                          src={resolveFaceImageUrl(assignmentDetails?.validation_start?.face_image_url)}
                          alt={t("taskDetailsLabels.capturedPhotoStart")}
                          sx={{
                            width: 48,
                            height: 48,
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #E4E6EF",
                            cursor: "pointer",
                          }}
                          crossOrigin="anonymous"

                        />
                      </a>
                    )
                    : "--",
                ],
                [t("taskDetailsLabels.endTask"), formatDateTime(endEvent?.local_timestamp || assignmentDetails?.timing?.actual_end_at)],
              ].map(([label, value], index) => renderDetailsRow(label, value, `start-${index}`))}
            </Box>

            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 2,
                mt: 1,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("taskDetailsLabels.taskCompletionDetails")}
            </CustomText>

            <Box   sx={{
              border: "2px solid  #091E4224",
              borderRadius: "10px",
              px: 2,
              py: 2,
              mt: 1.5,
              mb: 2.5,
              // backgroundColor: "#FBFCFE",
            }}>
              {[
                [t("taskDetailsLabels.scheduledEnd"), formatDateTime(assignmentDetails?.timing?.scheduled_end_at)],
                [t("taskDetailsLabels.actualEnd"), formatDateTime(assignmentDetails?.timing?.actual_end_at)],
                [t("taskDetailsLabels.completionStatus"), getEventDisplayValue(assignmentDetails?.timing?.completion_time_status)],
                [t("taskDetailsLabels.completionDelayMinutes"), formatDelayMinutes(assignmentDetails?.timing?.completion_delay_minutes)],
                [
                  t("taskDetailsLabels.durationMinutes"),
                  assignmentDetails?.started_at && assignmentDetails?.ended_at
                    ? formatDelayMinutes(
                        Math.max(
                          0,
                          Math.round(
                            (new Date(assignmentDetails?.ended_at) - new Date(assignmentDetails?.started_at)) / 60000
                          )
                        )
                      )
                    : "--",
                ],
                [t("taskDetailsLabels.faceVerificationEnd"), getEventDisplayValue(assignmentDetails?.validation_end?.face_validated ?? endEvent?.face_validated)],
                [t("taskDetailsLabels.locationVerificationEnd"), getEventDisplayValue(assignmentDetails?.validation_end?.location_validated ?? endEvent?.location_validated)],
                [t("taskDetailsLabels.systemCheckStatusEnd"), getEventDisplayValue(assignmentDetails?.validation_end?.system_validation_status ?? endEvent?.system_validation_status)],
                [t("taskDetailsLabels.reviewStatus"), getEventDisplayValue(endEvent?.review_status)],
                [t("taskDetailsLabels.evidenceFiles"), renderEvidenceGallery(endEvent?.evidence_files)],
                [
                  t("taskDetailsLabels.capturedPhotoEnd"),
                  assignmentDetails?.validation_end?.face_image_url
                    ? (
                      <a
                        href={resolveFaceImageUrl(assignmentDetails?.validation_end?.face_image_url)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "inline-flex" }}
                      >
                        <Box
                          component="img"
                          src={resolveFaceImageUrl(assignmentDetails?.validation_end?.face_image_url)}
                          alt={t("taskDetailsLabels.capturedPhotoEnd")}
                          sx={{
                            width: 48,
                            height: 48,
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #E4E6EF",
                            cursor: "pointer",
                          }}
                          crossOrigin="anonymous"

                        />
                      </a>
                    )
                    : "--",
                ],
              ].map(([label, value], index) => renderDetailsRow(label, value, `end-${index}`))}
            </Box>
         


            <CustomText
              sx={{
                ...textStyles.h1,
                fontSize: 18,
                mb: 3,
                mt: 2.5,
                fontWeight: 600,
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.documents")}
            </CustomText>
          

<Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    alignItems: "center",
    mb: 2,
  }}
>
  {Array.isArray(task.attachments) && task.attachments.length > 0 ? (
    task.attachments
      .filter((fileUrl) => typeof fileUrl === "string" && fileUrl.trim() !== "")
      .map((fileUrl, idx) => {
        if (!fileUrl) return null;

        const fileName = fileUrl.split("/").pop();
        const isPdf = fileUrl.toLowerCase().endsWith(".pdf");

        return (
          <Box
            key={idx}
            sx={{
              width: 200,
              minHeight: 230,
              border: "1px solid #E4E6EF",
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 1,
              background: "#F9FAFB",
            }}
          >
            {/* File Preview */}
            {isPdf ? (
              <>
                <img
                  src={document1}
                  alt="PDF document"
                  style={{ width: 60, height: 60, marginBottom: 8 }}
                />
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    mt: 1,
                    fontSize: 11,
                    mb:0.5,
                    textTransform: "none",
                    borderColor: "#0052CC",
                    color: "#0052CC",
                    "&:hover": { backgroundColor: "#0052CC", color: "#fff" },
                  }}
                  onClick={() =>
                    window.open(fileUrl, "_blank", "noopener,noreferrer")
                  }
                >
{t("upload.view")}                </Button>
              </>
            ) : (
              <img
               crossOrigin="anonymous"
                src={fileUrl}
                alt={fileName}
                style={{
                  width: "100%",
                  height: 150,
                  objectFit: "cover",
                  borderRadius: 4,
                  marginBottom: 8,
                }}
              />
            )}

            {/* File Name */}
            <Typography
              sx={{
                fontSize: 12,
                fontFamily: "Poppins, sans-serif",
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "100%",
              }}
              title={fileName}
            >
              {fileName}
            </Typography>
          </Box>
        );
      })
  ) : (
    <Typography
      sx={{
        fontSize: 14,
        color: "#5E5C5C",
        fontFamily: "Poppins, sans-serif",
      }}
    >
     {t("noAttachment")}
    </Typography>
  )}
</Box>

          </Box>

    
        </Box>
      </Box>
      <Box>
{/* Add Comment */}
<Box sx={{ p: 2, background: "#fff", mt: 2, border: "1px solid #091E4224", borderRadius: 1 }}>
  <CustomText
    sx={{
      ...textStyles.h1,
      fontSize: 18,
      fontWeight: 600,
      color: "#000",
      textAlign: "left",
    }}
  >
    {t("projectManagement.addComment")}
  </CustomText>


<Box sx={{ display: "flex", gap: 1, mt: 1, alignItems: "center" }}>

    <label htmlFor="comment-file-upload">
        <input
          id="comment-file-upload"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
     
        {uploadingAttachment ? (
  <CircularProgress size={24} sx={{ color: "#1976d2" }} />
) : !commentAttachment ? (
  <AttachFileIcon sx={{ cursor: "pointer", color: "#888" }} />
) : (
  <Box sx={{ position: "relative", display: "flex", gap: 1 }}>
    <img
      crossOrigin="anonymous"
      src={commentAttachment}
      alt="Attachment"
      style={{
        width: 60,
        height: 60,
        borderRadius: "30px",
        objectFit: "cover",
      }}
    />

    <ClearIcon
      onClick={handleRemoveAttachment}
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        cursor: "pointer",
        color: "white",
        backgroundColor: "rgba(0,0,0,0.5)",
        borderRadius: "50%",
      }}
    />
  </Box>
)}

      </label>

  {/* Comment input */}
  <input
    className="project_input"
    value={newComment}
    onChange={(e) => setNewComment(e.target.value)}
    placeholder={t("projectManagement.writeComment")}
    style={{ flex: 1, height: 40 }}
    disabled={sending}
  />

  {/* Add button */}
  <Button
    variant="contained"
    onClick={handleAddComment}
    disabled={sending}
    sx={{
      px: 2,
      backgroundColor: "#006EC2",
      color: "#fff",
      textTransform: "none",
      fontSize: 14,
      borderRadius: 1,
      height: 36,
      fontFamily: "Poppins, sans-serif",
    }}
  >
    {sending ? t("projectManagement.add") : t("projectManagement.add")}
  </Button>
</Box>



  {/* Comments list */}
 <Box sx={{ mt: 2, borderRadius: 2 }}>
  {comments.length === 0 ? (
    <CustomText sx={{ ...textStyles.h1, fontSize: 14, color: "#5E5C5C" }}>
 {t("projectManagement.noComments")}
    </CustomText>
  ) : (
    comments.map((c) => (
      <Box key={c.id} sx={{ p: 2, borderBottom: "1px solid #EEF2F7" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.6 }}>
               {c.attachments && c.attachments.length > 0 && (
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
         {c.attachments.map((file, idx) => (
    <Box
      key={idx}
      onClick={() => window.open(file, "_blank")}
      sx={{
        cursor: "pointer",
        position: "relative",
        width: 60,
        height: 60,
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      <img
        crossOrigin="anonymous"
        alt={c.author_name}
        src={file || emptyperson}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "10px",
        }}
      />
    </Box>
  ))}
            </Box>
          )}
            <Box>
              <CustomText
                sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: "#100F0F" }}
              >
                {c.author_name || "-"}
              </CustomText>

              <CustomText
            sx={{ fontSize: 15, fontWeight: 400, color: "#5E5C5C", lineHeight: 1.5 }}
          >
            {(i18n.language?.split("-")[0] === "es" ? c.body_es : c.body_en) || c.body}
          </CustomText>
            
            </Box>
          </Box>

          {/* ✅ Comment badge */}
          <Box sx={{display:"flex",flexWrap:"wrap", alignItems:"center",gap:1,}}>
          <Box
            sx={{
              px: 2,
              py: 0.4,
              borderRadius: "4px",
              backgroundColor: "#E4E6EB",
              fontSize: 12,
              fontWeight: 500,
              color: "#003149",
              display: "inline-block",
                 fontFamily: 'Nunito Sans, sans-serif',
            }}
          >
            Comment
          </Box>
            <CustomText
                sx={{ ...textStyles.h1, fontSize: 13, color: "#5E5C5C", fontWeight: 400,
                     fontFamily: 'Nunito Sans, sans-serif',
                 }}
              >
                {formatDateTime(c.created_at)}
              </CustomText>
              </Box>
        </Box>

       
      </Box>
    ))
  )}
</Box>
</Box>
 <ConfirmActionModal
        open={openModal}
        onClose={() => setOpenModal(false)} // Close modal on 'No'
        onConfirm={handleApiCall} // Call the API when 'Yes'
        action={selectedAction} // Pass the action ("cancel" or "complete") to the modal
      />
      <RatingModal
        open={openRatingModal}
        onClose={handleCloseRatingModal}
        taskId={task.id} // Pass the task ID
        onRatingSubmit={handleRatingSubmit} // Pass the callback function
        existingRating={task.productivity_rating || null} // Pass existing rating
        existingNotes={task.productivity_notes || null} // Pass existing notes
      />
      </Box>
    </>
  );
};
export default TaskDetails
